import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';

import SkillSet from './SkillSet';
import Project from './Project';
import Blog from './Blog';

import useTitle from '../useTitle';
import './Admin.scss';

const Admin = ( props ) => {

    useTitle( "Admin Panel | Kalihackz" );

    React.useEffect( () => {
        props.onLoad(20);
        props.onLoad(100);
    }, []);

    return (
			<main className="dashboard">
				<section className="dashboard__sidebar">
					<Link className="dashboard__item" to="/admin/skills">Skill Sets</Link>
					<Link className="dashboard__item" to="/admin/apis">APIs</Link>
					<Link className="dashboard__item" to="/admin/projects">Projects</Link>
					<Link className="dashboard__item" to="/admin/blogs">Blogs</Link>
				</section>
				<section className="dashboard__main">
					<div className="main__text">
						<Routes>
							<Route path="/" element={<SkillSet />} />
							<Route path="/skills" element={<SkillSet />} />
							<Route path="/projects" element={<Project />} />
							<Route path="/blogs" element={<Blog />} />
						</Routes>
					</div>
				</section>
			</main>
			 );

}

export default Admin;